import { formatEctPreviewDisplay } from '@/features/instruments/publish/review-publish/lib/previewPublishLogic'

/** Info page / tiles — title case units to match instrument info UI ("3 Mins"). */
export function formatTemplateEstCompletion(seconds: number): string {
  return formatEctPreviewDisplay(seconds)
    .replaceAll(/\bmins\b/g, 'Mins')
    .replaceAll(/\bsecs\b/g, 'Secs')
}

/** Template library tiles and preview — "Est. 3 mins" style. */
export function formatTemplateEstCompletionLabel(seconds: number): string {
  if (seconds <= 0) return 'Est. 0 mins'
  const body = formatEctPreviewDisplay(seconds)
  return `Est. ${body}`
}
